var jbcafes = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {

                "week_num": 1,
                "date": "2025-02-02",
                "season": "Winter 25'",
                "rating": " 🟤🟤🟤🟤🟤 5/5 <br> Pet Policy & Access 🟤🟤🟤🟤🟤 5/5 <br> Room & Comfort 🟤🟤🟤🟤🟤 5/5 <br> Dining & Common Areas 🟤🟤🟤🟤⚪️ 4/5 <br> On-Site Outdoor Space 🟤🟤🟤🟤🟤 5/5 <br> Pet Perks & Services 🟤🟤🟤🟤⚪️ 4/5",
                "name": "Amangiri • Dining Inclusive",
                "address": "1 Kayenta Road, Canyon Point, Utah 84741, USA",
                "city": "Canyon Point, Utah",
                "country": "USA",
                "category": "event",
                "month": "February",
                "collection_name": "celebration",
                "highlight": "A secluded luxury resort in the heart of the Utah desert, offering world-class spa treatments, private guided hikes, and unparalleled stargazing.",
                "experience_description": "Wake up to breathtaking desert landscapes, unwind in a private plunge pool, and explore slot canyons with expert guides. Amangiri is a masterpiece of minimalism and tranquility, blending seamlessly with the surrounding sandstone cliffs.",
                "caption": "Where the desert meets pure luxury\u2014unwind, explore, and soak in the serenity of Amangiri. \ud83c\udf35\u2728",
                "morning": "Start your day with a sunrise yoga session overlooking the mesas, followed by a gourmet breakfast on your private terrace.",
                "midday": "Indulge in a rejuvenating desert-inspired spa treatment, or embark on a private guided hike through the slot canyons.",
                "afternoon": "Float in the stunning rock-framed pool while sipping signature cocktails, or take a scenic hot-air balloon ride over the breathtaking Utah landscape.",
                "evening": "Dine under the stars with a private chef-curated tasting menu, featuring locally sourced ingredients and fine wine.",
                "website": "https://www.aman.com/resorts/amangiri",
                "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/utah1.png?v=1741074474",
                "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Screenshot_2025-03-04_at_7.42.49_PM.png?v=1741146190",
                "product_link": "https://jbthejetsetter.com/products/cruisin-through-canyon-dreams-in-utah",

               
            },
            "geometry": {
                "type": "Point",
                "coordinates": [-111.6111,
                    37.025]
            }
        }  
    ]
}